import actionTypes from '../actions/types';
import actionFactory from '../actions/actionsFactory/types';

const { RESET_USER_TRADES_PAGINATION } = actionFactory;
const TRADES_LIMIT = 40;

export const INITIAL_STATE = {
  userTrades: [],
  userTradesWithoutSymbol: [],
  userTradesStart: -1,
  userTradesEnd: -1,
};

const handleClearUserTradesData = (state, { symbol }) => (
  {
    ...state,
    userTrades: {
      ...state.userTrades,
      [symbol]: [],
    },
  }
);

const handleClearUserTradesDataWithBefore = (state) => (
  { ...state, userTradesWithoutSymbol: [] }
);

const handleUpdateUserTradesData = (state, {
  symbol, data,
}) => {
  const batchSize = data?.length;
  if (!batchSize) return state;
  const userTrades = [];
  data.forEach((el) => {
    const singleTrade = {
      p: el.price,
      q: el.qty,
      s: el.symbol,
      T: el.time,
      a: el.tradeId,
      f: el.fee,
      fa: el.feeAsset,
      tq: el.totalQuota,
      d: el.side,
      ba: el.baseAsset,
      qa: el.quoteAsset,
    };
    userTrades.push(singleTrade);
  });

  userTrades.sort((a, b) => b.T - a.T); // sort by time, DESC

  const newState = { ...state, userTrades: { ...(state.userTrades || {}) } };
  let list = newState.userTrades[symbol] = state.userTrades[symbol] || [];
  if (list && list.some(({ a }) => a === userTrades[0].a)) {
    if (__DEV__) console.warn('Got trade behind last trade id. ignoring.', userTrades[0].a);
    return state;
  }

  list = newState.userTrades[symbol] =
  userTrades.concat(newState.userTrades[symbol]); // must be new

  if (list.length > TRADES_LIMIT) {
    list.length = TRADES_LIMIT; // chop one off the end
  }
  // used in UserDataProvider#shouldComponentUpdate
  newState.userTrades[symbol].__lastBatchSize__ = batchSize;
  return newState; // trigger update
};

export const handleSetUserTradesDataPeriod = (state, { data: { period, start, end } }) => (
  {
    ...state,
    userTradesDataPeriod: period,
    userTradesStart: start,
    userTradesEnd: end,
  }
);

const handleSetUserTradesDataWithBefore = (state, {
  data, pagination, isScrollToBottom,
}) => {
  if (!data) return { ...state, userTradesPagination: pagination };
  const batchSize = data.length;
  if (!batchSize) return state;
  const userTrades = [];
  data.forEach((el) => {
    const singleTrade = {
      p: el.price,
      q: el.qty,
      s: el.symbol,
      T: el.time,
      a: el.tradeId,
      f: el.fee,
      fa: el.feeAsset,
      tq: el.totalQuota,
      d: el.side,
      ba: el.baseAsset,
      qa: el.quoteAsset,
    };
    userTrades.push(singleTrade);
  });

  userTrades.sort((a, b) => b.T - a.T); // sort by time, DESC
  const newState = {
    ...state,
    userTradesWithoutSymbol: isScrollToBottom ? [...state.userTradesWithoutSymbol, ...userTrades]
      : userTrades,
    userTradesPagination: pagination,
  };
  return newState;
};

export const resetUserTradesPagination = (state) => ({
  ...state,
  userTradesPagination: { ...state.userTradesPagination, page: 0, pages: 1 },
});

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_TRADES_DATA:
      state = handleClearUserTradesData(state, action);
      return handleUpdateUserTradesData(state, action);
    case actionTypes.CLEAR_USER_TRADES_DATA:
      return handleClearUserTradesData(state, action);
    case actionTypes.SET_USER_TRADES_DATA_PERIOD:
      return handleSetUserTradesDataPeriod(state, action);
    case actionTypes.SET_USER_TRADES_DATA_WITH_BEFORE:
      state = handleClearUserTradesDataWithBefore(state);
      return handleSetUserTradesDataWithBefore(state, action);
    case RESET_USER_TRADES_PAGINATION:
      return resetUserTradesPagination(state, action);
    default:
      return state;
  }
};
